import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import AuthContext from './authContext';
import { getAPI } from '../apis/backend/apiNode';

const CompanieContext = createContext([]);

export const CompanieContextProvider = ({ children }) => {
	const { userData } = useContext(AuthContext);
	const [companies, setCompanies] = useState([]);
	const [companie, setCompanie] = useState();

	useEffect(() => {
		const fetchSocieties = async () => {
			try {
				const response = await getAPI('society');
				const societiesList = response?.data || [];

				setCompanies(societiesList);

				if (societiesList?.length > 0) {
					const initial = societiesList[0];
					setCompanie(initial);
				}
			} catch (err) {
			}
		};

		!!userData?.id && fetchSocieties();
	}, [userData?.id]);

	const value = useMemo(
		() => ({
			companies,
			companie,
			setCompanies,
			setCompanie,
		}),
		[companies, companie],
	);
	return <CompanieContext.Provider value={value}>{children}</CompanieContext.Provider>;
};

export default CompanieContext;
